"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../../Utilities");
var ShimmerLine_base_1 = require("./ShimmerLine.base");
var ShimmerLine_styles_1 = require("./ShimmerLine.styles");
exports.ShimmerLine = Utilities_1.styled(ShimmerLine_base_1.ShimmerLineBase, ShimmerLine_styles_1.getStyles);
//# sourceMappingURL=ShimmerLine.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/Shimmer/ShimmerLine/ShimmerLine.js
// module id = 830
// module chunks = 0